import App from 'app/app.js';

function AddressValidationService($http) {
  this.validateAddress = function (address) {
    let results = [];
    return $http
      .post('addressValidation/doContactVerify', {
        address
      })
      .then((response) => {
        if (response.data.Records) {
          results = response.data.Records[0];
        }
      })
      .catch((response) => {
        results = response.data;
      })
      .then(
        () => results,
        () => results
      );
  };
}

App.service('AddressValidationService', ['$http', 'ContentStore', AddressValidationService]);
